'use client';

import { useState } from 'react';

import { env } from '@ria-client/env';
import { useHasWPSession } from '../WordpressEditWrapper/hook';

export interface WordpressControlsProps {
  id: string;
  lastModified?: string;
  contentType: 'Review' | 'Roundup' | 'Calculator' | 'Article' | 'Hub';
}

export function WordpressControls({ id, lastModified, contentType }: WordpressControlsProps) {
  const { hasWPSession } = useHasWPSession();
  const [revalidating, setRevalidating] = useState(false);

  if (!hasWPSession) return null;

  const revalidate = async () => {
    if (revalidating) return;

    setRevalidating(true);
    try {
      const response = await fetch(`/api/revalidate?path=${window.location.pathname}`, {
        method: 'POST',
      });
      if (response.status === 200) window.location.reload();
    } finally {
      setRevalidating(false);
    }
  };

  return (
    <>
      {/* z-[9999]: keeps the WP admin bar above page chrome. */}
      <iframe
        className="absolute top-0 z-[9999] h-8 w-full border-0"
        src={`${env.NEXT_PUBLIC_NW_URL}/blog/nw-admin-bar/?post_id=${id}`}
        title="WP Admin Bar"
      />
      <style>{'html { margin-top: 32px; }'}</style>
      {lastModified ? (
        // top-[180px]: legacy WP metadata placement.
        <p className="typography-text-small absolute right-4 top-[180px]">
          Last modified at {lastModified}
        </p>
      ) : null}
      {/* top-[205px]: legacy WP refresh-link placement. */}
      <button
        className="typography-text-small absolute right-4 top-[205px]"
        disabled={revalidating}
        onClick={revalidate}
        type="button"
      >
        {revalidating ? `Refreshing ${contentType}` : `Refresh ${contentType}`}
      </button>
    </>
  );
}
